import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckAvailabilityComponent } from './check-availability.component';
import { AdvancedSearchComponent } from './advanced-search.component';
import { CheckAvailabilityRoutingModule } from './check-availability-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckAvailabilityService } from './check-availability.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatProgressBarModule,
  MatCardModule, 
  MatTooltip,
  MatTooltipModule} from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    CheckAvailabilityRoutingModule,
    MatAutocompleteModule,
	MatButtonModule,
	MatButtonToggleModule,
	MatCheckboxModule,
	MatDialogModule,
  MatIconModule,
  MatTooltipModule,
  BrowserAnimationsModule,  
	MatInputModule,
	MatProgressSpinnerModule,
	MatSelectModule,
	MatSidenavModule,
	MatSliderModule,
	MatSlideToggleModule,
  MatProgressBarModule,
  MatCardModule,
	FormsModule, 
	ReactiveFormsModule
  ],
  providers: [CheckAvailabilityService],  
  declarations: [CheckAvailabilityComponent, AdvancedSearchComponent]
})
export class CheckAvailabilityModule { }



// WEBPACK FOOTER //
// ./src/app/check-availability/check-availability.module.ts